import AuthorProfile from '@bridebook/web/app-basic/components/articles/auth-profile/author-profile';
import { ArticleShare } from '@bridebook/web/app-basic/components/articles/share';
import BookmarkButton from '@bridebook/web/app-basic/components/bookmark-button/bookmark-button';
import ShareButton from '@bridebook/web/app-basic/components/share-button/share-button';
import { getIsMobile } from '@bridebook/web/app-basic/lib/app/selectors';
import { getArticle } from '@bridebook/web/app-basic/lib/article/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { Box } from '@bridebook/ui';
import { Link } from '@bridebook/web/app-shared/components/link/link';
import { getTagsList } from '@bridebook/web/app-shared/lib/articles/utils';
import { UrlHelper } from '@bridebook/web/lib/url-helper';
import SearchBar from '@bridebook/web/app-shared/components/articles/search-bar/search-bar';
import componentStyles from './header-controls.style';

interface IProps {
  pinImage: string;
  withSubtitle?: boolean;
}

const ArticleHeaderControls = ({ pinImage, withSubtitle }: IProps) => {
  const article = useSelector(getArticle);
  const isMobile = useSelector(getIsMobile);

  const getArticleTagLink = (tagSlug?: string) =>
    `${UrlHelper.advice}${tagSlug ? '/' + tagSlug : ''}`;

  const tagsList = getTagsList(article);

  const styles = componentStyles();

  const content = (
    <Box style={styles.content} data-name="article-header-controls">
      {!isMobile && !withSubtitle && (
        <Box style={styles.controlsWrap}>
          {tagsList.length > 0 && (
            <Box style={styles.tagsOuter}>
              <Box style={styles.tagsWrap}>
                <SearchBar />
                {tagsList.map((tag, i) => (
                  <Link key={`link-${tag.slug}-${i}`} href={getArticleTagLink(tag.slug)}>
                    <Box style={styles.tag} id={`article-id-${tag.slug}`}>
                      {tag.name}
                    </Box>
                  </Link>
                ))}
              </Box>
            </Box>
          )}
        </Box>
      )}
      <Box style={styles.authorInfoAndShare(withSubtitle)}>
        <AuthorProfile withSubtitle={withSubtitle} article={article} />
        <Box style={styles.rightWrap}>
          <ArticleShare pinImage={pinImage} />
          <Box flexDirection="row">
            <Box style={styles.buttonWrap}>{article && <BookmarkButton />}</Box>
            <Box style={styles.buttonWrap}>{article && <ShareButton />}</Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );

  const ContentWrap = <Box>{content}</Box>;

  return <Box style={styles.wrapper}>{ContentWrap}</Box>;
};

export default ArticleHeaderControls;
